<template>
  <div>
    <b-row>
      <b-col cols="8">

      

    <b-row>

      <b-col
        cols="21"
        xl="8"
        class="d-flex justify-content-between flex-column"
        >
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="userData.avatar"
            size="104px"
            rounded
          />
          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ userData.member_code }}
              </h4>
              <span class="card-text">{{ userData.zh_name }} {{  userData.en_name }}</span>
            </div>
            <!-- <div class="d-flex flex-wrap">
              <b-button
                variant="primary"
              >
                Edit
              </b-button>
              <b-button
                variant="outline-danger"
                class="ml-1"
              >
                Delete
              </b-button>
            </div> -->
          </div>
        </div>

        <div class="d-flex align-items-center mt-2">
          <div class="d-flex align-items-center mr-2">
            <b-avatar
              variant="light-primary"
              rounded
            >
              <feather-icon
                icon="DollarSignIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{ data && data.stats && data.stats.monthly_sales > 0 ? data.stats.monthly_sales : 0 }}
              </h5>
              <small>每月消費</small>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <b-avatar
              variant="light-success"
              rounded
            >
              <feather-icon
                icon="TrendingUpIcon"
                size="18"
              />
            </b-avatar>
            <div class="ml-1">
              <h5 class="mb-0">
                {{ data && data.stats && data.stats.total_sales > 0 ? data.stats.total_sales : 0 }}
              </h5>
              <small>總消費</small>
            </div>
          </div>
        </div>
      </b-col>

      <b-col
        cols="12"
        xl="4"
      >
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="UserIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Deposit</span>
            </th>
            <td class="pb-50">
             ${{data && data && data.deposit > 0 ? data.deposit : 0 }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CheckIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Debit</span>
            </th>
            <td class="pb-50 text-capitalize">
              ${{data && data.debit != null ? data.debit : 0 }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="StarIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Overdue</span>
            </th>
            <td
              class="pb-50 text-capitalize"
              :class="{ 'text-danger text-bold': data && data.overdue > 0 }"
            >
              ${{data && data.overdue != null ? data.overdue : 0 }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon
                icon="CreditCardIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">Credit Card</span>
            </th>
            <td class="pb-50">
             {{data && data.credit_card != null ? data.credit_card : 0 }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon
                icon="PhoneIcon"
                class="mr-75"
              />
              <span class="font-weight-bold">File Saved</span>
            </th>
            <td>
              {{data && data.file_saved != null ? data.file_saved : 0 }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>

  </b-col>
    <b-col cols="4">


        <b-card
    no-body
    class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <h5 class="mb-0">
        {{data.membership.code ? data.membership.code : 'No Active Membership'}}
      </h5>
      <b-badge variant="light-primary">
        {{data && data.membership && data.membership.type ? data.membership.type : ''}}
      </b-badge>
      <small class="text-muted w-100">{{ data && data.membership && data.membership.end ? data.membership.end : '' }}</small>
    </b-card-header>

    <b-card-body>
      <ul class="list-unstyled my-1">
        <li>
          <b-badge variant="warning" ><span class="align-middle">HKD ${{data.membership.amount ? data.membership.amount : '0.00'}}</span></b-badge>
        </li>
        <li class="my-25">
          <!-- <span class="align-middle" v-if="data">Auto Renew</span> -->
        </li>

      </ul>
      
    </b-card-body>
  </b-card>
    </b-col>
    </b-row>
    
    <hr class="mt-2"/>
    <h4>Membership Timeline</h4>
    <!-- <HorizontalTimeline
      :user-data="userData"
      :items="data.timeline"
      > -->
    <HorizontalTimeline
      :user-data="userData"
      >
    </HorizontalTimeline>
    <hr />
    <b-row class="mt-2">
      <b-col cols="7">
            <h4>Last 5 Entries</h4>
         <b-table
        :fields="entry_fields"
        :items="data.entry_record"
        responsive="sm"
        striped
      >
      <!-- A virtual column -->
       <template #cell(center_name)="data">
        <b-badge variant="primary" class="d-block">
          {{ data.value }}
        </b-badge>
       </template>
      <template #cell(status)="data">
        <b-badge v-if="data.value == 'GRANT'" variant="light-success" class="d-block">
          {{ data.value }}
        </b-badge>
        <b-badge v-if="data.value == 'DENY'" variant="light-danger" class="d-block">
          {{ data.value }}
        </b-badge>
      </template>
    </b-table>
      </b-col>
      <b-col cols="5">
         <h4>Personal Training Package</h4>
           <b-table
        :fields="[{key:'package_name',label:'Package Name'},{key:'expire_at',label:'Expire At'},{key:'balance',label:'Balance'}]"
        :items="data.package_record"
        striped
        responsive="sm"
      />

  </b-col>  
      
    </b-row>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import PackageAddNew from './SidebarNewClass.vue'
import router from '@/router'
import HorizontalTimeline from './HorizontalTimeline.vue'
import {
      BCard,
    BCardHeader,
BListGroup, BListGroupItem,
  BTable, BAvatar, BProgress, BCardBody, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton, BInputGroupPrepend,
} from 'bootstrap-vue'

export default {
  components: {
    router,
    BListGroup, BListGroupItem,
     BProgress, 
    HorizontalTimeline,
    PackageAddNew,
    BTable,
    BAvatar,
    BBadge,
    BCardHeader,
    BRow,
    BCard,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BPagination,
    BCardCode,
    BTable,
    BButton,
    BFormGroup,
    BAvatar,
    BCardBody,
    BBadge,
    vSelect,
  },
  directives: {
    Ripple,
  },
data() {
    return {
      data: {
        entry_record: [],
        package_record: [],
        membership_timeline: [],
        current_membership: null
      },
      entry_fields: [
        { key: 'center_name', label: 'Center' },
        { key: 'in_time', label: 'IN' },
        { key: 'out_time', label: 'OUT' },
        { key: 'status', label: 'Status' },
        {}
      ],
      entry_record: [],
    }
  },


  props: {
    userData : {
      type: Object
    }
  },
  watch: {

  },
  created() {
    this.get_data()
  },
  methods: {  
  get_data() {
        this.$http.get(process.env.VUE_APP_API_BASE+`/member/${router.currentRoute.params.id}/dashboard/`)
          .then(res => {
            this.data = res.data
          })
      },
  },
}
</script>

<style lang="scss">
.b-table-selectable{
  .feather{
    font-size: 1.3rem;
  }
}

</style>
